import { ThemeColors } from 'src/shared/styles/variables';
import styled from 'styled-components';

export const CreateAppContainer = styled('div')`
  .breadcrumbs-wrapper {
    margin: 20px auto;
  }
`;

export const Section = styled('div')`
  padding-bottom: 48px;
  &:not(:last-of-type) {
    border-bottom: 1px solid ${ThemeColors.sectionSeparator};
  }
  &:not(:first-of-type) {
    padding-top: 48px;
  }
  .action-panel {
    display: flex;
    justify-content: flex-end;
    margin-top: 24px;
  }

  .tags-section {
    display: flex;
    align-items: flex-start;

    .tags-container {
      flex: 1;

      .tags {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
      }
    }
  }

  .table-actions {
    text-align: right;
  }
`;
